var _path;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSummaryExternalDispatches(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 25,
    height: 20,
    viewBox: "0 0 25 20",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.9231 0H0V16.9231H3.07692C3.07692 18.6225 4.45451 20 6.15385 20C7.85318 20 9.23077 18.6225 9.23077 16.9231H15.3846C15.3846 18.6225 16.7622 20 18.4615 20C20.1609 20 21.5385 18.6225 21.5385 16.9231H24.6154V9.23077C24.6154 6.68177 22.5491 4.61538 20 4.61538H16.9231V0ZM16.9231 7.69231V10.7692H21.5385V7.69231H16.9231Z",
    fill: "#E16C00"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSummaryExternalDispatches);
export default __webpack_public_path__ + "static/media/summary-external-dispatches.7d1e81d4.svg";
export { ForwardRef as ReactComponent };